var GoeHistoryController = (function () {
    function GoeHistoryController(topic) {
        this.topic = topic;
        this.isAutoEligibilityGoe = false;
        this.isDisplayTable = false;
        this.isDisplayChecklist = false;
        this.component = 'eligibilityGoeHistory';
        this.visible = false;
        if (this.topic.goeHistoryCheck) {
            this.goeHistoryCheck = this.topic.goeHistoryCheck;
        }
        if (this.topic.checksData) {
            this.isAutoEligibilityGoe = this.topic.checksData.isAutoEligibilityGoe;
        }
        if (this.isAutoEligibilityGoe) {
            if (!this.goeHistoryCheck || this.goeHistoryCheck.errorMessage) {
                this.errorMessage = 'GOE History Check was not performed';
                this.isDisplayTable = false;
                this.isDisplayChecklist = true;
            }
            else if (!this.goeHistoryCheck.isPassed) {
                this.errorMessage = 'GOE History Check found discrepancies';
                this.isDisplayTable = true;
                this.isDisplayChecklist = true;
            }
            else if (this.goeHistoryCheck.isPassed) {
                this.isDisplayTable = true;
                this.isDisplayChecklist = false;
                this.message = "GOE History Check havn't found discrepancies";
            }
        }
    }
    GoeHistoryController.prototype.toggleVisibility = function () {
        this.visible = !this.visible;
        return this.visible;
    };
    GoeHistoryController.$inject = ['topic'];
    return GoeHistoryController;
}());
angular
    .module('application')
    .component('eligibilityGoeHistory', new GoeHistoryComponent());

//# sourceMappingURL=goeHistoryController.js.map
